
import axios, { AxiosResponse } from 'axios';
import React, { useRef, useEffect, useState , ChangeEvent} from 'react';
import './style.css';

import LoanReportTable from '../../components/Table/LoanReport/LoanReportTable';
import { LoanReportTableData, LoanReportFilterInput } from '../../interface/ILoanReport';
import {ApiResponse} from '../../interface/IResponse';
import loanReportService from '../Loan/loanReportService';

interface IModalProps {
    message: string,
    isOpen: boolean,
    onClose: () => void;
    loanReportData: LoanReportTableData[];
}

const LoanReportModal: React.FC<IModalProps> = ({message, isOpen = false, onClose, loanReportData }) => {




      useEffect(function(){
        (async () => {
  
          document.querySelector('.loader-container')?.classList.add('loader');
              
          
          
          document.querySelector('.loader-container')?.classList.remove('loader');
        })();
      },[]);

    if (!isOpen) {
        return null;
      }
    
      return (
        <div className="modal-overlay">
          <div className="modal-content">
           
            <br />
            <div className='center-middle font-size-17px'>
                <LoanReportTable data={loanReportData}></LoanReportTable>
             </div>
            <br />
            <div className="center-middle">
                <button type="button" className='btn-white-green-2 center-middle' onClick={onClose}  >Close</button>
            </div>
          </div>
        </div>
      );

}

export default LoanReportModal;